import React, { memo } from 'react';
import { Box } from '@mui/material';
import { useReactionsDisplay } from 'features/room-reactions/hooks/useReactionsDisplay';
import ReactionFloater, {
  ANIMATION_DURATION_SECONDS,
} from 'features/room-reactions/components/ReactionFloater';

export type ReactionsOverlayProps = {
  pipMode?: boolean;
};

const ReactionsOverlay = ({ pipMode = false }: ReactionsOverlayProps) => {
  const { items, containerRef, containerHeight, removeItem } = useReactionsDisplay();

  const flyFromY = pipMode ? 'calc(-1 * var(--toolbar-width))' : '0';
  const flyToY = `calc(-${pipMode ? 0.8 : 0.9} * ${containerHeight}px)`;
  const flyDuration = `${containerHeight < 600 ? ANIMATION_DURATION_SECONDS * 0.5 : ANIMATION_DURATION_SECONDS}s`;

  return (
    <Box
      data-testid="reactions-overlay-container"
      ref={containerRef}
      sx={(theme) => ({
        zIndex: theme.zIndex.mobileStepper,
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        overflow: 'hidden',
        '--fly-from-y': flyFromY,
        '--fly-to-y': flyToY,
        '--fly-duration': flyDuration,
      })}
    >
      {items.map((item) => (
        <ReactionFloater key={item.id} item={item} onAnimationEnd={removeItem} />
      ))}
    </Box>
  );
};

export default memo(ReactionsOverlay);
